
import currencyConverter from "../common/currency-converter.vue";
export default {
  components: { currencyConverter },
  props: {
    order: {
      default: {}
    },
    printMode: {
      default: false
    }
  },
  computed: {
    isCompleted() {
      return this.order.status == this.$constants.OrderStatuses.COMPLETED.id;
    },
    isCancelled() {
      return this.order.status == this.$constants.OrderStatuses.CANCELLED.id;
    },
    isActive() {
      return !this.isCompleted && !this.isCancelled;
    }
  }
};
